import { createContext } from "react";

export const TabsProvider = createContext(null);
export const BalanseGoods = createContext(null);
export const Broadcast = createContext(null);
